import { FileTextOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import VideoIcon, { DocumentIcon } from "../../../icons/js/VideoIcon";
import ImageIcon from "../../../icons/js/ImageIcon";

const IMAGE_FILE = "image/jpg, image/jpeg, image/png, image/gif";
const VIDEO_FILE = "video/*";
const DOCUMENT_FILE =
  "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf";

const MmsMediaButtons = props => {
  const {
    handleMediaSharing,
    mediaRef,
    videoRef,
    documentRef,
    handleMediaEvent,
    color,
    mediaProcessingLoader,
  } = props;

  const loadingIndicator = <LoadingOutlined style={{ fontSize: 16 }} spin />;

  return (
    <>
      {mediaProcessingLoader ? (
        <div className="flex flex-col items-center justify-center gap-2 py-4">
          <Spin indicator={loadingIndicator} />
          <span className="text-sm text-gray-500">Processing file...</span>
        </div>
      ) : (
        <div className="flex gap-5 flex-col justify-between text-center">
          <span
            className="flex items-center cursor-pointer"
            onClick={() => handleMediaSharing("image")}
          >
            <ImageIcon color={color} className="text-[20px] mr-1.5" />
            Image
          </span>
          <span
            className="flex items-center cursor-pointer"
            onClick={() => handleMediaSharing("video")}
          >
            <VideoIcon color={color} className="text-[20px] mr-1.5" />
            Video
          </span>
          <span
            className="flex items-center cursor-pointer"
            onClick={() => handleMediaSharing("document")}
          >
            <DocumentIcon className=" text-[20px] mr-1.5" />
            Document
          </span>
        </div>
      )}
      <input
        type="file"
        style={{ display: "none" }}
        multiple
        ref={mediaRef}
        accept={IMAGE_FILE}
        onChange={handleMediaEvent}
      />
      <input
        type="file"
        style={{ display: "none" }}
        multiple
        ref={videoRef}
        accept={VIDEO_FILE}
        onChange={handleMediaEvent}
      />
      <input
        type="file"
        style={{ display: "none" }}
        multiple
        ref={documentRef}
        accept={DOCUMENT_FILE}
        onChange={handleMediaEvent}
      />
    </>
  );
};

export default MmsMediaButtons;
